import React from 'react';
import moment from 'moment';
import clone from 'clone';
import './FileBlock.scss';
import AddToCartButton from '../../../Store/AddToCartButton';

class FileBlock extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      hovered: false
    }
  }

  mouseOver = () => {
    this.setState({
      hovered: true
    })
  };

  mouseLeave = () => {
    this.setState({
      hovered: false
    })
  };

  render(){
    let customColors = clone(this.props.customColors) || {
      author: {},
      title: {},
      date: {},
      background: {},
      backgroundHover: {},
      backgroundActive: {},
      overlay: {}
    };
    let file = this.props.file;
    file.helper.on('thumbnailLoaded', () => {
      this.forceUpdate();
    }, this);
    //let href = FW.inEditor() ? '/admin/files/' + file.get('id') : '/file/' + file.get('id');
    //let target = FW.inEditor() ? '_blank' : '';
    let href = '/file/' + file.get('id');
    let target = this.props.openInNewTab || (file.get('extension') === 'pdf' && FW.store.get('site').prop('disable_pdf_view')) ? '_blank' : '_self';
    const subtitle = this.props.showPassageAsSubtitle ? file.get('reference') || '' : file.get('subtitle');
    const showThumbnail = this.props.showThumbnail == null ? true : this.props.showThumbnail;
    const featured = file.helper.featuredUrl(800);
    let style = this.props.singleFile ?
      {backgroundImage: 'url(' + featured + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', height: '200px', backgroundSize: 'contain'} :
      {backgroundImage: 'url(' + featured + ')'};
    let image = <div className="file-icon"><span
      className={'fa fa-' + file.icon}/></div>;
    if(featured){
      if(this.props.contain_image){
        image = <img src={featured} style={{width: '100%'}} alt={file.get('title')}/>
      } else {
        image = <div className="media-image" style={style}>
          <div className="media-image-overlay" style={customColors.overlay}/>
        </div>;
      }
    }
    let fontStyle = this.props.options && this.props.options.font ? {
      fontFamily: 'inherit'
    } : {};

    let userOwned = FW.store.get('user') && FW.store.get('user').get('purchased_files').indexOf(file.get('id')) >= 0;

    if (file.get('site_id') !== FW.store.get('site').get('id')) {
      const site = FW.store.get('sites').findWhere({
        id: file.get('site_id')
      });
      href = site.get('public_url') + 'file/' + file.get('id');
      target = '_blank';
    }

    const fileClass = this.props.active ? "media-file active" : "media-file";
    const backgroundColor = this.props.active ? customColors.backgroundActive : (this.state.hovered ? customColors.backgroundHover : customColors.background);
    return <div className={fileClass} style={backgroundColor}>
      <a onMouseOver={this.mouseOver} onMouseLeave={this.mouseLeave} href={href} onClick={(e) => {
        this.props.onClick(e, file);
      }} target={target}>
        <div style={this.props.singleFile ? {textAlign: 'center', wordBreak: 'break-word'} : {wordBreak: 'break-word'}}>
          {showThumbnail ? image : null}
          <h3 style={Object.assign(customColors.title, fontStyle)}>{file.get('title')}</h3>
          {this.props.showSubtitle ? <h5 style={Object.assign(customColors.title, fontStyle)} id={'subtitle'}>{subtitle}</h5> : null}
          <h4 style={Object.assign(customColors.author, fontStyle)}>{file.get('author')} <small style={Object.assign(customColors.date, fontStyle)}>{this.props.hide_dates ? '' : moment(file.get('display_date')).format('LL')}</small></h4>
        </div>
      </a>
      {file.get('visibility') === 'private' ? <AddToCartButton
        title={file.get('title')}
        price={file.get('price')}
        id={file.get('id')}
        type="file"
        image={file.helper.featuredUrl(800)}
        owned={userOwned}
      /> : null}
    </div>;
  }

}

export default FileBlock;
